import React, { useState, useEffect, Fragment } from 'react';
import ReactModal from 'react-modal';
import secureLocalStorage from 'react-secure-storage';
import { Button, ButtonHalf } from '../../../theme/button';
import styles from './Logbooks.module.css';
import { useActivePage } from '../../../contexts/ActivePageContext';
import { useAuth } from '../../../contexts/AuthContext';
import { ReactComponent as ArrowUp } from '../../../assets/icons/svg/arrow-up-bold.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/svg/arrow-down-bold.svg';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/svg/arrow-left-bold.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/svg/arrow-right-bold.svg';
import { ReactComponent as Refresh } from '../../../assets/icons/svg/refresh.svg';


ReactModal.setAppElement('#root');

export default function Logbooks({ navigation }) {
  const [logbooks, setLogbooks] = useState([]);
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(null);
  const [selectedTableForAppend, setSelectedTableForAppend] = useState(null);
  const [appendDirection, setAppendDirection] = useState(null);
  const [remainingLogbooks, setRemainingLogbooks] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const { setActivePage } = useActivePage();
  const { getValidToken } = useAuth();

    let masterTableTemplate = [
          { name: "Date", variations: ["flight date", "year"], exactVariations: ["date"], index: 1, dataType: "date", autoMatch: "true" },
          { name: "Aircraft Make & Model", variations: ["aircraft make & model", "aircraft type", "aircraft model", "aircraft make"], exactVariations: ["aircraft make & model"], index: 2, dataType: "string", autoMatch: "true" },
          { name: "Aircraft Ident.", variations: ["aircraft ident.", "aircraft id", "tail number", "registration number", "aircraft ident"], exactVariations: ["aircraft ident."], index: 3, dataType: "string", autoMatch: "true" },
          { name: "From", variations: ["from time"], exactVariations: ["from"], index: 4, dataType: "string", autoMatch: "true" },
          { name: "To", variations: ["destination", "arrival", "destination airport", "to time"], exactVariations: ["to"], index: 5, dataType: "string", autoMatch: "true" },
          { name: "Remarks", variations: ["remarks"], exactVariations: ["remarks"], index: 6, dataType: "string", autoMatch: "true" },
          { name: "Day Takeoffs", variations: ["to day night"], exactVariations: ["day takeoffs"], index: 7, dataType: "number", numberFormat: "integer", autoMatch: "true" },
          { name: "Night Takeoffs", variations: ["night t/o landings"], exactVariations: ["night takeoffs"], index: 8, dataType: "number", numberFormat: "integer", autoMatch: "true" },
          { name: "Day Landings", variations: ["ldg day night", "ldg. day night"], exactVariations: ["day landings"], index: 9, dataType: "number", numberFormat: "integer", autoMatch: "true" },
          { name: "Night Landings", variations: ["night t/o landings"], exactVariations: ["night landings"], index: 10, dataType: "number", numberFormat: "integer", autoMatch: "true" },
          { name: "Approaches", variations: ["no. instr. appr.", "app no. type", "appr."], exactVariations: ["approaches"], index: 11, dataType: "number", numberFormat: "integer", autoMatch: "true" },
          { name: "SEL Time", variations: ["sel time", "single engine land time", "single engine land", "single- engine land", "airplane sel"], exactVariations: ["se"], index: 12, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "MEL Time", variations: ["mel time", "multi-engine land time", "multi-engine land", "multi- engine land", "airplane mel"], exactVariations: ["me"], index: 13, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Turbine", variations: ["turbine", "turbine time", "turbine aircraft"], exactVariations: ["turbine"], index: 14, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Jet", variations: ["jet time", "jet aircraft"], exactVariations: ["jet"], index: 15, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Night", variations: ["night time", "night hours"], exactVariations: ["night"], index: 16, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Actual Instrument", variations: ["actual ins.", "actual", "actual instrument"], exactVariations: ["actual ins."], index: 17, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Sim Instrument", variations: ["sim ins.", "simulated instrument", "instrument (hood)", "simulated instr."], exactVariations: ["sim ins."], index: 18, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Night Dual Received", variations: ["night dual received", "night dual", "night dual flight"], exactVariations: ["night dual received"], index: 19, dataType: "number", numberFormat: "decimal", autoMatch: "false" },
          { name: "Night/PIC", variations: ["night/pic", "night pilot-in-command", "night pic hours"], exactVariations: ["night/pic"], index: 20, dataType: "number", numberFormat: "decimal", autoMatch: "false" },
          { name: "Simulator Time", variations: ["time of session", "flight simulator", "ground"], exactVariations: ["simulator time"], index: 21, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Simulator Type", variations: ["type and device no."], exactVariations: ["Simulator Type"], index: 22, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Sim Ins. Aircraft", variations: ["sim ins. aircraft", "simulated aircraft", "simulator aircraft"], exactVariations: ["sim ins. aircraft"], index: 23, dataType: "number", numberFormat: "decimal", autoMatch: "false" },
          { name: "Sim Ins. FTD", variations: ["sim ins. ftd", "simulator time", "ftd simulator time"], exactVariations: ["sim ins. ftd"], index: 24, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Dual Received / Flight Training", variations: ["dual received", "flight training", "received"], exactVariations: ["dual received / flight training"], index: 25, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Solo", variations: ["solo flight time", "solo hours"], exactVariations: ["solo"], index: 26, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "PIC", variations: ["pilot-in-command", "pilot in command", "pic hours", "pilot-in- command"], exactVariations: ["pic"], index: 27, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "SIC", variations: ["co-pilot", "second in command", "second pilot", "sic hours", "second in"], exactVariations: ["sic"], index: 28, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Cross Country", variations: ["cross country", "cross-country flight", "cross-country time", "cross- country", "country"], exactVariations: ["cross country"], index: 29, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Cross Country Instruction Received", variations: ["cross country instruction received", "cross country training", "cross-country instruction"], exactVariations: ["cross country instruction received"], index: 30, dataType: "number", numberFormat: "decimal", autoMatch: "false" },
          { name: "Solo Cross Country", variations: ["solo cross country", "solo cross-country flight", "solo cross country time"], exactVariations: ["solo cross country"], index: 31, dataType: "number", numberFormat: "decimal", autoMatch: "false" },
          { name: "Dual Given", variations: ["instructor examined", "instructor ck.", "as flight instructor"], exactVariations: ["dual given"], index: 32, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Total Time", variations: ["duration of flight", "total duration of flight"], exactVariations: ["total time"], index: 33, dataType: "number", numberFormat: "decimal", autoMatch: "true" },
          { name: "Day", exactVariations: ["day"], index: 34, dataType: "number", numberFormat: "decimal", autoMatch: "true" }
      ];

  // Store in sessionStorage
  sessionStorage.setItem('masterTableTemplate', JSON.stringify(masterTableTemplate));

  // Load user info and logbooks
  const userDataOnPageLoad = async () => {
    setLoading(true);
    try {
      const user = localStorage.getItem('user');
      const userObject = JSON.parse(user);
      if (userObject?.email) {
        const result = await queryLogbooksByUserEmail();
        setLogbooks(Array.isArray(result) ? result : []);
      }
    } catch (e) {
      console.error('Error loading user data:', e);
      setLogbooks([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    userDataOnPageLoad();
  }, []);

  const queryLogbooksByUserEmail = async () => {
    const API_URL =
      'https://ngyk2k01bl.execute-api.us-east-1.amazonaws.com/prod/getLogbooks';
    const validToken = await getValidToken();

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${validToken}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API fetch error:', error);
      return [];
    }
  };

  const deleteTable = async (userHashID) => {
    const API_URL =
      'https://ngyk2k01bl.execute-api.us-east-1.amazonaws.com/prod/deleteLogbook';
    const validToken = await getValidToken();
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${validToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ hashedID: userHashID }),
      });
      if (!response.ok) {
        throw new Error(`Delete failed with status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting logbook:', error);
      return null;
    }
  };

  const appendUpdateTable = async (
    userHashID,
    appendedData,
    cols,
    rows
  ) => {
    const API_URL =
      'https://ngyk2k01bl.execute-api.us-east-1.amazonaws.com/prod/appendUpdateLogbook';
    const validToken = await getValidToken();
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${validToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          hashedID: userHashID,
          appendedData,
          newColumns: cols,
          newRows: rows,
        }),
      });
      if (!response.ok) {
        throw new Error(`Append update failed with status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error append updating logbook:', error);
      return null;
    }
  };

  const handleDeleteTable = async (HashedIDParam) => {
    if (window.confirm('Are you sure you want to delete this logbook?')) {
      try {
        await deleteTable(HashedIDParam);
        await userDataOnPageLoad();
      } catch (error) {
        console.error('Error deleting table:', error);
      }
    }
  };

  const handleAppendData = () => {
    const tempRemainingLogbooks = logbooks.filter(
      (_, index) => index !== activeDropdownIndex
    );
    setRemainingLogbooks(tempRemainingLogbooks);
    setIsModalOpen(true);
  };

  const handleTableSelection = (logbook) => {
    setSelectedTableForAppend(logbook);
    showConfirmationAlert(logbook, logbooks[activeDropdownIndex]);
  };

  const showConfirmationAlert = async (selectedTable, sourceTable) => {
    if (!appendDirection) {
      alert('Please select a direction to append.');
      return;
    }
    setAppendDirection(null);
    if (
      !window.confirm(
        `Are you sure you want to append data from "${sourceTable.Name}" to "${selectedTable.Name}"? This will delete the old logbook...`
      )
    ) {
      return;
    }
    try {
      const result = await queryLogbooksByUserEmail();
      setLogbooks(Array.isArray(result) ? result : []);

      const sourceData = JSON.parse(sourceTable.Data);
      const targetData = JSON.parse(selectedTable.Data);

      const sourceRows = parseInt(sourceTable.Rows);
      const sourceColumns = parseInt(sourceTable.Columns);
      const targetRows = parseInt(selectedTable.Rows);
      const targetColumns = parseInt(selectedTable.Columns);

      let newRows, newColumns;

      switch (appendDirection) {
        case 'up':
        case 'down':
          newRows = sourceRows + targetRows - 1;
          newColumns = Math.max(sourceColumns, targetColumns);
          break;
        case 'left':
        case 'right':
          newRows = Math.max(sourceRows, targetRows);
          newColumns = sourceColumns + targetColumns;
          break;
        default:
          newRows = sourceRows + targetRows - 1;
          newColumns = Math.max(sourceColumns, targetColumns);
          break;
      }

      const fillWithBlanks = (rows, columns) =>
        Array.from({ length: rows }, () => Array(columns).fill(''));

      const calculateNewData = () => {
        if (appendDirection === 'up' || appendDirection === 'down') {
          const sourceHeaders = sourceData[0];
          const targetHeaders = targetData[0];
          const finalHeaders = Array.from(
            new Set([...targetHeaders, ...sourceHeaders])
          );
          const alignDataWithHeaders = (headers, data) => {
            return data.slice(1).map((row) => {
              const rowMap = {};
              headers.forEach((key, index) => {
                rowMap[key] = row[index];
              });
              return finalHeaders.map((header) => rowMap[header] ?? '');
            });
          };
          const sourceBody = alignDataWithHeaders(sourceHeaders, sourceData);
          const targetBody = alignDataWithHeaders(targetHeaders, targetData);
          const newData = fillWithBlanks(
            sourceBody.length + targetBody.length + 1,
            finalHeaders.length
          );
          newData[0] = finalHeaders;
          if (appendDirection === 'up') {
            sourceBody.forEach((row, i) => (newData[i + 1] = row));
            targetBody.forEach(
              (row, i) => (newData[i + 1 + sourceBody.length] = row)
            );
          } else {
            targetBody.forEach((row, i) => (newData[i + 1] = row));
            sourceBody.forEach(
              (row, i) => (newData[i + 1 + targetBody.length] = row)
            );
          }
          return newData;
        }

        const newData = fillWithBlanks(newRows, newColumns);
        switch (appendDirection) {
          case 'left':
            for (let i = 0; i < newRows; i++) {
              for (let j = 0; j < sourceColumns; j++) {
                if (sourceData[i] && sourceData[i][j] !== undefined) {
                  newData[i][j] = sourceData[i][j];
                }
              }
              for (let j = 0; j < targetColumns; j++) {
                if (targetData[i] && targetData[i][j] !== undefined) {
                  newData[i][j + sourceColumns] = targetData[i][j];
                }
              }
            }
            break;
          case 'right':
            for (let i = 0; i < newRows; i++) {
              for (let j = 0; j < targetColumns; j++) {
                if (targetData[i] && targetData[i][j] !== undefined) {
                  newData[i][j] = targetData[i][j];
                }
              }
              for (let j = 0; j < sourceColumns; j++) {
                if (sourceData[i] && sourceData[i][j] !== undefined) {
                  newData[i][j + targetColumns] = sourceData[i][j];
                }
              }
            }
            break;
          default:
            for (let i = 0; i < targetRows; i++) {
              for (let j = 0; j < newColumns; j++) {
                newData[i][j] = targetData[i][j];
              }
            }
            for (let i = targetRows; i < newRows; i++) {
              for (let j = 0; j < newColumns; j++) {
                newData[i][j] = sourceData[i - targetRows][j];
              }
            }
            break;
        }
        return newData;
      };

      const appendedData = calculateNewData();

      await appendUpdateTable(
        selectedTable.HashedID,
        appendedData,
        appendedData[0].length.toString(),
        appendedData.length.toString()
      );

      await deleteTable(sourceTable.HashedID);
      await userDataOnPageLoad();
    } catch (error) {
      console.error('Error appending data:', error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    userDataOnPageLoad();
    setAppendDirection(null);
  };

  return (
    <div className={styles.logbooksContainer}>
      <div className={styles.titleWithRefresh}>
        <h1>Logbooks</h1>
        <button
          onClick={userDataOnPageLoad}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          }}
          title="Refresh logbooks"
        >
          <Refresh className={styles.refreshIcon} />
        </button>
      </div>
      {loading ? (
          <p style={{ textAlign: 'center', marginTop: '50px' }}>Loading logbooks...</p>
        ) : logbooks && logbooks.length > 0 ? (
        logbooks.map((logbook, index) => (
          <div key={index} className={styles.logbookEntry}>
            <div className={styles.logbookText}>{logbook.Name}</div>
            <div className={styles.logbookButtons}>
              <Button
                style={{ width: 'auto', padding: '8px 16px' }}
                onClick={() => {
                  const array = JSON.parse(logbook.Data);
                  const logbookIndex = {
                    table: logbook.Name,
                    columns: logbook.Columns,
                    rows: logbook.Rows,
                    data: array,
                  };
                  const jsonOutput = [logbookIndex];

                  // Store in localStorage so Edit can pick it up
                  localStorage.setItem("jsonOutput", JSON.stringify(jsonOutput));
                  localStorage.setItem("HashedID", logbook.HashedID);
                  setActivePage("edit");

                }}
              >
                Edit
              </Button>

              <a
                style={{ width: 'auto', padding: '8px', minWidth: 40 }}
                onClick={() =>
                  setActiveDropdownIndex(
                    activeDropdownIndex === index ? null : index
                  )
                }
              >
                <img
                  src={require('../../../assets/icons/png/dots-horizontal.png')}
                  alt="Menu"
                  className={styles.ellipsisIcon}
                />
              </a>

              {activeDropdownIndex === index && (
                <div className={styles.dropdown}>
                  <Button style={{ width: '100%' }} onClick={handleAppendData}>
                    Append
                  </Button>
                  <Button
                    style={{ width: '100%', backgroundColor: 'red' }}
                    onClick={() => handleDeleteTable(logbook.HashedID)}
                  >
                    Delete
                  </Button>
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div>
          <h2 className={styles.emptyTitle}>No Logbooks Available</h2>
          <p className={styles.emptyText}>
            Start logging your pages with our mobile app! Track your entries
            seamlessly and never lose a record.
          </p>
          <a href="https://loggable.net" target="_blank" className={styles.ctaButton}>
            Download the App
          </a>
        </div>
      )}
      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Append Logbook Modal"
        className={styles.modalContent}
        overlayClassName={styles.modalOverlay}
      >
        <h3>Choose a direction to append data:</h3>
        <div className={styles.appendDirections}>
          {['up', 'down', 'left', 'right'].map((dir) => {
            let ArrowIcon;
            switch (dir) {
              case 'up':
                ArrowIcon = ArrowUp;
                break;
              case 'down':
                ArrowIcon = ArrowDown;
                break;
              case 'left':
                ArrowIcon = ArrowLeft;
                break;
              case 'right':
                ArrowIcon = ArrowRight;
                break;
              default:
                break;
            }

            return (
              <button
                key={dir}
                className={appendDirection === dir ? styles.selected : ''}
                onClick={() => setAppendDirection(dir)}
              >
                <ArrowIcon className={styles.arrowIcon} />
              </button>
            );
          })}
        </div>

        <h3>Choose a table to append data to:</h3>
        {remainingLogbooks.length > 0 ? (
          <ul>
            {remainingLogbooks.map((item, i) => (
              <li key={i}>
                <a onClick={() => handleTableSelection(item)}>
                  {item.Name}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p>No other logbooks available.</p>
        )}
        <Button className={styles.cancelButton} onClick={closeModal}>
          Cancel
        </Button>
      </ReactModal>
    </div>
  );
}
